/**
 * How big a competition may get.
 *
 * MIRRORS `app/limits.py`, which is where the reasoning lives and which is the
 * one that actually decides — the server refuses regardless, because the wizard
 * is not the only way in (the roll-up self-join reaches the same rows, and a
 * frozen Capacitor bundle reaches the same endpoints with none of this code in
 * it). These exist so the wizard can say so BEFORE a request is refused, which
 * is the difference between a limit and an error.
 *
 * If you change one, change the other.
 */
export const MAX_PLAYERS = 120;
export const MAX_ROUNDS = 6;

/** Named as the golf, not as a constraint — someone who has hit this is
 *  deciding whether to run two competitions, not debugging a form. */
export const playersOverBy = (count) => Math.max(0, count - MAX_PLAYERS);
export const roundsOverBy = (count) => Math.max(0, count - MAX_ROUNDS);

export const playerLimitMessage = (count) => {
    const over = playersOverBy(count);
    if (!over) return null;
    return `A competition holds ${MAX_PLAYERS} players — this one has ${count}. `
        + `Remove ${over}, or run a second competition for the rest of the field.`;
};

export const roundLimitMessage = (count) => {
    const over = roundsOverBy(count);
    if (!over) return null;
    return `A competition can run up to ${MAX_ROUNDS} rounds — this one has ${count}. `
        + 'Split a longer series into two competitions.';
};
